module.exports = __webpack_public_path__ + "img/Diamond2.ffc96de1.jpg";